import Vue from "vue";
import VueRouter from "vue-router";
import store from "../store";
import { loginDestination } from "./loginDestination";
const Login = () => import("../views/Login.vue");
const Active = () => import("../views/Active.vue");
const Forgot = () => import("../views/Forgot.vue");
const Campanhas = () => import("../views/campanhas/index.vue");
const CampanhasImport = () => import("../views/campanhas/import.vue");
const Detalhes = () => import("../views/campanhas/detalhes.vue");
const Temzap = () => import("../views/temzap/index.vue");
const TemzapImport = () => import("../views/temzap/import.vue");
const TemzapDetalhes = () => import("../views/temzap/detalhes.vue");
const Respostas = () => import("../views/respostas/index.vue");
const Chat = () => import("../views/chat/index.vue");
const RelatorioEnvio = () => import("../views/relatorios/relatorioEnvio.vue");
const RelatorioEnviosClientes = () => import("../views/relatorios/relatorioEnviosClientes.vue");
const RelatorioMeireles = () => import("../views/relatorios/relatorioMeireles.vue");
const RelatorioTemzap = () => import("../views/relatorios/relatorioTemzap.vue");
const RelatorioChats = () => import("../views/relatorios/relatorioChats.vue");
const RelatorioSessao = () => import("../views/relatorios/relatorioSessao.vue");
const RelatorioDiario = () => import("../views/relatorios/relatorioDiario.vue");
const RelatorioResumo = () => import("../views/relatorios/relatorioResumo.vue");
const RelatorioChatsFinalizados = () => import("../views/relatorios/relatorioChatsFinalizados.vue");
const RelatorioAnalitico = () => import("../views/relatorios/RelatorioAnalitico.vue");
const Faturamento = () => import("../views/faturamento/index.vue");
const Operadores = () => import("../views/operadores/index.vue");
const OperadoresForm = () => import("../views/operadores/form.vue");
const MsgProibida = () => import("../views/operadores/msgProibida.vue");
const MsgProibidaForm = () => import("../views/operadores/msgProibidaForm.vue");
const NumerosProibido = () => import("../views/operadores/numerosBlackList.vue");
const NovoNumeroProibido = () => import("../views/operadores/novoNumeroProibido.vue");
const Avaliacoes = () => import("../views/operadores/avaliacoes.vue");
const Centrocusto = () => import("../views/centrocusto/index.vue");
const CentrocustoForm = () => import("../views/centrocusto/form.vue");
const Tag = () => import("../views/tag/index.vue");
const TagForm = () => import("../views/tag/form.vue");
const Auditoria = () => import("../views/auditoria/index.vue");
const Avaliacao = () => import("../views/avaliacao/index.vue");
const Config = () => import("../views/config/index.vue");
const Saldo = () => import("../views/config/saldo.vue");
const User = () => import("../views/User.vue");
const Rastrear = () => import("../views/rastrear/index.vue");
const NovaConta = () => import("../views/nova-conta/index.vue");
const NovaContaBlueSend = () => import("../views/nova-conta/novaContaBlueSend.vue");
const NovaContaBVTelecom = () => import("../views/nova-conta/novaContaBVTelecom.vue");
const Home = () => import("../views/home/index.vue");
const Suporte = () => import("../views/suporte/index.vue");
const Ticket = () => import("../views/suporte/form.vue");
const PreMensagem = () => import("../views/preDefinidas/index.vue");
const PreMensagemForm = () => import("../views/preDefinidas/form.vue");

Vue.use(VueRouter);

const routes = [
  {
    path: '/relatorios/faturamento-clientes',
    name: 'FaturamentoClientesBluesend',
    component: () => import('../views/faturamento/clientesBluesend.vue'),
    meta: { requiresLogin: true, requiresFaturamentoClientesBluesend: true }
  },
  {
    path: "/",
    redirect: "/home"
  },
  {
    path: "/home",
    name: "Home",
    component: Home
  },
  {
    path: "/login",
    name: "Login",
    component: Login
  },
  {
    path: "/active",
    name: "Active",
    component: Active
  },
  {
    path: "/reset-senha",
    name: "SendEmailResetPassword",
    component: Forgot
  },
  {
    path: "/reset-senha/:token",
    name: "PasswordChange",
    component: Forgot
  },
  {
    path: "/campanhas",
    name: "Campanhas",
    component: Campanhas,
    meta: { requiresLogin: true, requiresAcesso: true, acesso: "campanhas" }
  },
  {
    path: "/campanhas/import",
    name: "CampanhasImport",
    component: CampanhasImport,
    meta: { requiresLogin: true, requiresAcesso: true, acesso: "campanhas" }
  },
  {
    path: "/campanhas/detalhes/:id",
    name: "CampanhasDetalhes",
    component: Detalhes,
    meta: { requiresLogin: true, requiresAcesso: true, acesso: "campanhas" }
  },

  {
    path: "/temzap",
    name: "Validacao",
    component: Temzap,
    meta: { requiresLogin: true, requiresAcesso: true, acesso: "validacao" }
  },
  {
    path: "/temzap/import",
    name: "ValidacaoImport",
    component: TemzapImport,
    meta: { requiresLogin: true, requiresAcesso: true, acesso: "validacao" }
  },
  {
    path: "/temzap/detalhes/:id",
    name: "ValidacaoDetalhes",
    component: TemzapDetalhes,
    meta: { requiresLogin: true, requiresAcesso: true, acesso: "validacao" }
  },
  {
    path: "/respostas",
    name: "Respostas",
    component: Respostas,
    meta: { requiresLogin: true, requiresAdmin: true }
  },

  {
    path: "/chat",
    name: "Chat",
    component: Chat,
    alias: "/chats",
    meta: { requiresLogin: true, requiresAcesso: true, acesso: "chats" }
  },
  {
    path: "/chat/messages/:id",
    name: "ChatMessagesID",
    component: Chat,
    alias: "/chats/messages/:id",
    meta: { requiresLogin: true }
  },

  {
    path: "/config",
    name: "Config",
    component: Config,
    meta: { requiresLogin: true, requiresAdmin: true }
  },

  {
    path: "/saldo",
    name: "Saldo",
    component: Saldo,
    meta: { requiresLogin: true, requiresAdmin: true }
  },

  {
    path: "/user",
    name: "User",
    component: User,
    meta: { requiresLogin: true }
  },

  {
    path: "/avaliacoes",
    name: "Avaliacoes",
    component: Avaliacoes,
    meta: { requiresLogin: true }
  },

  {
    path: "/operadores",
    name: "Operadores",
    component: Operadores,
    meta: { requiresLogin: true }
  },
  {
    path: "/operadores/form",
    name: "OperadoresForm",
    component: OperadoresForm,
    meta: { requiresLogin: true, requiresAdmin: true }
  },
  {
    path: "/operadores/form/:id",
    name: "OperadoresFormEdit",
    component: OperadoresForm,
    meta: { requiresLogin: true, requiresAdmin: true }
  },
  {
    path: "/operadores/avaliacoes/:id",
    name: "OperadoresAvaliacoes",
    component: Avaliacoes,
    meta: { requiresLogin: true, requiresAdmin: true }
  },
  {
    path: "/operadores/msgproibida",
    name: "OperadoresMsgProibida",
    component: MsgProibida,
    meta: { requiresLogin: true, requiresAdmin: true }
  },
  {
    path: "/operadores/msgproibida/nova",
    name: "OperadoresMsgProibidaNova",
    component: MsgProibidaForm,
    meta: { requiresLogin: true, requiresAdmin: true }
  },
  {
    path: "/operadores/msgproibida/:id",
    name: "OperadoresMsgProibidaEdit",
    component: MsgProibidaForm,
    meta: { requiresLogin: true, requiresAdmin: true }
  },
  {
    path: "/operadores/numerosproibido",
    name: "OperadoresNumerosProibido",
    component: NumerosProibido,
    meta: { requiresLogin: true, requiresAdmin: true }
  },

  {
    path: "/operadores/novonumeroproibido",
    name: "NovoNumeroProibido",
    component: NovoNumeroProibido,
    meta: { requiresLogin: true, requiresAdmin: true }
  },

  {
    path: "/numerosproibido",
    name: "NumerosProibido",
    component: NumerosProibido,
    meta: { requiresLogin: true, requiresAdmin: true }
  },

  {
    path: "/avaliacao/:id",
    name: "Avaliacao",
    component: Avaliacao,
    meta: { requiresLogin: false }
  },

  {
    path: "/centros",
    name: "Centros",
    component: Centrocusto,
    meta: { requiresLogin: true, requiresAdmin: true }
  },
  {
    path: "/centros/form",
    name: "CentrosForm",
    component: CentrocustoForm,
    meta: { requiresLogin: true, requiresAdmin: true }
  },
  {
    path: "/centros/form/:id",
    name: "CentrosFormEdit",
    component: CentrocustoForm,
    meta: { requiresLogin: true, requiresAdmin: true }
  },

  {
    path: "/rastrear",
    name: "Rastrear",
    component: Rastrear,
    alias: "/relatorios/rastrear-envio",
    meta: { requiresLogin: true, acesso: "rastrear" }
  },

  {
    path: "/tag",
    name: "Tag",
    component: Tag,
    meta: { requiresLogin: true, requiresAdmin: true }
  },
  {
    path: "/tag/form",
    name: "TagForm",
    alias: "/relatorios/respostas",
    component: TagForm,
    meta: { requiresLogin: true, requiresAdmin: true }
  },
  {
    path: "/tag/form/:id",
    name: "TagFormEdit",
    component: TagForm,
    meta: { requiresLogin: true, requiresAdmin: true }
  },

  {
    path: "/relatorios/auditoria",
    name: "Relatórios/Auditoria",
    component: Auditoria,
    meta: { requiresLogin: true }
  },
  {
    path: "/relatorios/faturamento",
    name: "Relatórios/Faturamento",
    component: Faturamento,
    meta: { requiresLogin: true, requiresAdmin: true }
  },
  {
    path: "/relatorios/relatorio-envio",
    name: "Relatórios/Relatório de Envio",
    component: RelatorioEnvio,
    alias: "/relatorios/envio",
    meta: { requiresLogin: true, requiresAcesso: true, acesso: "relatorio_campanha" }
  },
  {
    path: "/relatorios/relatorio-envio-clientes",
    name: "Relatórios/Relatório de Envio Clientes",
    component: RelatorioEnviosClientes,
    meta: { requiresLogin: true, requiresEnviosClientes: true }
  },
  {
    path: "/relatorios/relatorio-meireles",
    name: "Relatórios/Relatório Meireles",
    component: RelatorioMeireles,
    meta: { requiresLogin: true, requiresRelatorioMeireles: true }
  },
  {
    path: "/relatorios/relatorio-temzap",
    name: "Relatórios/Relatório tem zap",
    component: RelatorioTemzap,
    alias: "/relatorios/validacao",
    meta: { requiresLogin: true, requiresAcesso: true, acesso: "relatorio_validacao" }
  },
  {
    path: "/relatorios/relatorio-analitico",
    name: "Relatórios/Relatório analítico",
    component: RelatorioAnalitico,
    alias: "/relatorios/analitico",
    meta: { requiresLogin: true, requiresAcesso: true, acesso: "relatorio_campanha" }
  },
  {
    path: "/relatorios/relatorio-chats",
    name: "Relatórios/Relatório de Chats",
    component: RelatorioChats,
    alias: ["/relatorios/chats", "/relatorios/conversas"],
    meta: { requiresLogin: true, requiresAcesso: true, acesso: "relatorio_campanha" }
  },
  {
    path: "/relatorios/relatorio-chats-finalizados",
    name: "Relatórios/Relatório de Chats Finalizados",
    component: RelatorioChatsFinalizados,
    alias: "/relatorios/chats-finalizados",
    meta: { requiresLogin: true, requiresAcesso: true, acesso: "relatorio_campanha" }
  },
  {
    path: "/relatorios/relatorio-diario",
    name: "Relatórios/Relatório diario",
    component: RelatorioDiario,
    alias: "/relatorios/diario",
    meta: { requiresLogin: true, requiresAcesso: true, acesso: "relatorio_campanha" }
  },
  {
    path: "/relatorios/relatorio-resumo",
    name: "Relatórios/Relatório resumo",
    component: RelatorioResumo,
    alias: "/relatorios/resumo-envios",
    meta: { requiresLogin: true, requiresAcesso: true, acesso: "relatorio_campanha" }
  },
  {
    path: "/relatorios/relatorio-sessao",
    name: "Relatórios/Relatório de Sessao",
    component: RelatorioSessao,
    alias: "/relatorios/sessao",
    meta: { requiresLogin: true, requiresAcesso: true, acesso: "relatorio_campanha" }
  },
  {
    path: "/suporte",
    name: "Suporte",
    component: Suporte,
    meta: { requiresLogin: true }
  },
  {
    path: "/suporte/form",
    name: "Ticket",
    component: Ticket,
    meta: { requiresLogin: true }
  },
  {
    path: "/suporte/form/:id",
    name: "Ticket",
    component: Ticket,
    meta: { requiresLogin: true }
  },
  {
    path: "/nova-conta-novavida",
    name: NovaConta,
    component: NovaConta,
    meta: {}
  },
  {
    path: "/nova-conta-bluesend",
    name: "NovaContaBlueSend",
    component: NovaContaBlueSend,
    meta: { requiresLogin: true, requiresBluesendPrincipal: true }
  },  {
    path: "/nova-conta-bvtelecom",
    name: "NovaContaBVTelecom",
    component: NovaContaBVTelecom,
    meta: { requiresLogin: true, requiresBVTelecomPrincipal: true }
  },
  {
    path: "/premensagem",
    name: "PreMensagem",
    component: PreMensagem,
    meta: { requiresLogin: true }
  },
  {
    path: "/premensagem/form",
    name: "PreMensagemForm",
    component: PreMensagemForm,
    meta: { requiresLogin: true }
  },
  {
    path: "/premensagem/form/:id",
    name: "PreMensagemFormEdit",
    component: PreMensagemForm,
    meta: { requiresLogin: true }
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, from, next) => {
  const hasToken = localStorage.getItem("token");
  const restaurandoSessao = hasToken && !store.state.isLogged;

  if (restaurandoSessao) {
    store.commit("login", JSON.parse(localStorage.getItem("user")));
  }

  if (store.state.user && store.state.user.supervisor &&
    (/^\/(config|operadores|nova-conta-bluesend|nova-conta-bvtelecom)(\/|$)/i.test(to.path) ||
      to.meta.requiresBluesendPrincipal || to.meta.requiresBVTelecomPrincipal)) {
    return next({ path: loginDestination(store.state.user) });
  }

  if (to.meta.requiresFaturamentoClientesBluesend && store.state.isLogged) {
    const user = store.state.user || {};
    const master = '66eac8eef58389f70fad372d';
    const permitido = user.admin && ((!user.operador && String(user._id) === master) ||
      (user.operador && String(user.usuario) === master));
    return permitido ? next() : next({ path: loginDestination(user) });
  }

  if (to.meta.requiresLogin && !store.state.isLogged) {
    next({ name: "Login" });
  } else if (to.name === "Login" && hasToken && store.state.isLogged) {
    next({ path: loginDestination(store.state.user) });
  } else if (to.meta.requiresEnviosClientes) {
    const user = store.state.user;
    const userId = user && user._id ? user._id.toString() : "";
    const allowedIds = [
      "626a87fec9cf2abcd1265acf",
      "63fe25095bd52da93a558322",
      "677bef54e735894ed49a2fe4",
      "690ce44750612ed5cb237b15",
    ];

    if (user && user.admin && allowedIds.indexOf(userId) !== -1) {
      next();
    } else {
      next({ path: loginDestination(store.state.user) });
    }
  } else if (to.meta.requiresRelatorioMeireles) {
    const user = store.state.user;
    const userId = user && user._id ? user._id.toString() : "";

    if (user && user.admin && userId === "677bef54e735894ed49a2fe4") {
      next();
    } else {
      next({ path: loginDestination(store.state.user) });
    }
  } else if (to.meta.requiresBluesendPrincipal) {
    const user = store.state.user || {};
    const userId = user._id ? user._id.toString() : "";
    const parentUserId = user.usuario ? user.usuario.toString() : "";
    const allowedAccountIds = [
      "66eac8eef58389f70fad372d",
      
    ];

    if (!user.supervisor && user.admin && (allowedAccountIds.indexOf(userId) !== -1 ||
      (user.operador && allowedAccountIds.indexOf(parentUserId) !== -1))) {
      next();
    } else {
      next({ path: loginDestination(store.state.user) });
    }
  } else if (to.meta.requiresBVTelecomPrincipal) {
    const user = store.state.user || {};
    const userId = user._id ? user._id.toString() : "";
    const parentUserId = user.usuario ? user.usuario.toString() : "";
    const allowedAccountIds = [
      "6a675909cef45d1dc0e482d3",
    ];

    if (!user.supervisor && user.admin && (allowedAccountIds.indexOf(userId) !== -1 ||
      (user.operador && allowedAccountIds.indexOf(parentUserId) !== -1))) {
      next();
    } else {
      next({ path: loginDestination(store.state.user) });
    }
  } else if (to.meta.requiresAcesso && to.meta.acesso) {
    if (store.state.user && store.state.user.acessos_lzv2 && store.state.user.acessos_lzv2.indexOf(to.meta.acesso) !== -1) {
      next();
    } else {
      next({ path: loginDestination(store.state.user) });
    }
  } else if ((to.meta.requiresAdmin && !store.state.user) || (to.meta.requiresAdmin && !store.state.user.admin)) {
    next({ path: loginDestination(store.state.user) });
  } else {
    next();
  }
});

export default router;
